import { Serie } from "@nivo/line";
import { StateHistoryData } from "src/components/monitoring/senec-state-history-chart/stateHistoryTypes";
import { CompleteTheme } from "@nivo/core";
import { SenecBaseTheme } from "src/styles/senecBaseTheme";

export function dateFormatterWithMilliseconds(lng: string): Intl.DateTimeFormat {
    return new Intl.DateTimeFormat(lng, {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        fractionalSecondDigits: 3,
    });
}

export function transformDataToSeries(
    sortedData: StateHistoryData[],
    uniqueStates: string[],
    minTime: Date,
    maxTime: Date,
): Serie[] {
    const mappedData: Serie[] = sortedData.map((entry, index) => {
        return {
            id: `${entry.state}.${index}`,
            data: [
                { x: entry.from, y: entry.translation },
                { x: entry.to, y: entry.translation },
            ],
            color: entry.color,
            tooltipText: entry.tooltipText,
            entry,
        };
    });
    // Push an extra set of data to make chart lines not appear directly on the x-Axis but rather above it
    mappedData.push({
        id: "",
        data: [
            {
                x: minTime,
                y: "",
            },

            {
                x: maxTime,
                y: "",
            },
        ],
        color: "transparent",
    });

    // align with y-Chart order aka. uniqueStates order
    mappedData.sort((a, b) => {
        return uniqueStates.indexOf(a.data[0].y!.toString()) - uniqueStates.indexOf(b.data[0].y!.toString());
    });

    return mappedData;
}

export function getLineChartTheme(theme: SenecBaseTheme): Partial<CompleteTheme> {
    return {
        tooltip: {
            container: {
                borderRadius: "12px",
                border: `1px solid ${theme.palette.neutralGray20.main}`,
                position: "absolute",
                width: "fit-content",
                zIndex: 24,
                pointerEvents: "none",
            },
        },
    } as Partial<CompleteTheme>;
}

export function getDynamicHeightOffset(items: number): number {
    switch (true) {
        case items < 3:
            return -100;
        case items < 4:
            return -50;
        case items < 5:
            return 0;
        default:
            return (items - 4) * 75;
    }
}
